















































import { Component, Prop, Vue } from "vue-property-decorator";
import { renewPush } from "@/api/renewal";
@Component({
  name: "detailsDialog",
  components: {},
})
export default class extends Vue {
  pushViewbtns = true;
  @Prop() list!: any;
  created() {}
  pushClick() {
    const _t = this;
    const array = [] as any;
    _t.list.forEach((a: any) => {
      array.push(a.account_id);
    });
    renewPush({ ids: array }).then((res: any) => {
      console.log(res);
      if (res.error_code === 0) {
        _t.$message({
          type: "success",
          message: "推送成功!",
        });
        this.$emit("closeView", "push");
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  closeView() {
    this.$emit("closeView", "close");
  }
}
